import {
  BriefDeliverableStatusEnum,
  UploaderType,
} from "@entities/brief/lib/constants";

export function getTaskStatusColorClassKey(
  status?: BriefDeliverableStatusEnum,
  approvalPendingOn?: UploaderType
): string {
  if (!status) return "taskStatusPending";

  const isInReview =
    approvalPendingOn === UploaderType.Brand &&
    status === BriefDeliverableStatusEnum.PendingApproval;
  if (isInReview) {
    return "taskStatusInReview";
  }

  const isNeedsApproval =
    status !== BriefDeliverableStatusEnum.Pending &&
    status !== BriefDeliverableStatusEnum.Completed &&
    status !== BriefDeliverableStatusEnum.Approved &&
    status !== BriefDeliverableStatusEnum.EditsRequested &&
    !isInReview;

  if (isNeedsApproval) {
    return "taskStatusNeedsApproval";
  }

  const statusMap: Record<string, string> = {
    [BriefDeliverableStatusEnum.Completed]: "taskStatusCompleted",
    [BriefDeliverableStatusEnum.Approved]: "taskStatusCompleted",
    [BriefDeliverableStatusEnum.PendingApproval]: "taskStatusPendingApproval",
    [BriefDeliverableStatusEnum.EditsRequested]: "taskStatusEditsRequested",
    [BriefDeliverableStatusEnum.Pending]: "taskStatusPending",
  };
  return statusMap[status] || "taskStatusPending";
}

export function getTaskStatusLabel(
  status?: BriefDeliverableStatusEnum,
  approvalPendingOn?: UploaderType
): string {
  if (!status) return "Pending";

  const isInReview =
    approvalPendingOn === UploaderType.Brand &&
    status === BriefDeliverableStatusEnum.PendingApproval;
  if (isInReview) {
    return "In Review";
  }
  if (status === BriefDeliverableStatusEnum.EditsRequested)
    return "Changes Requested";

  const isNeedsApproval =
    status !== BriefDeliverableStatusEnum.Pending &&
    status !== BriefDeliverableStatusEnum.Completed &&
    status !== BriefDeliverableStatusEnum.Approved &&
    !isInReview;

  if (isNeedsApproval) {
    return "Needs Approval";
  }

  if (status === BriefDeliverableStatusEnum.PendingApproval)
    return "Pending Approval";

  return status;
}

export function getTaskIconColorClassKey(
  status?: BriefDeliverableStatusEnum,
  approvalPendingOn?: UploaderType
): string {
  if (!status) return "";

  const isCompletedOrApproved =
    status === BriefDeliverableStatusEnum.Completed ||
    status === BriefDeliverableStatusEnum.Approved;
  if (isCompletedOrApproved) {
    return "timelineSegmentIconCompleted";
  }

  if (status === BriefDeliverableStatusEnum.EditsRequested) {
    return "timelineSegmentIconEditsRequested";
  }

  const isInReview = approvalPendingOn === UploaderType.Brand;
  if (isInReview) {
    return "timelineSegmentIconNeedsApproval";
  }

  const isNeedsApproval =
    status !== BriefDeliverableStatusEnum.Pending &&
    !isCompletedOrApproved &&
    !isInReview;

  if (isNeedsApproval || status === BriefDeliverableStatusEnum.PendingApproval) {
    return "timelineSegmentIconActive";
  }

  return "";
}
